import { render, staticRenderFns } from "./Pillars.vue?vue&type=template&id=53fa06f5"
import script from "./Pillars.vue?vue&type=script&lang=js"
export * from "./Pillars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports